import React, { useState } from "react";
import NavLogo from "../../../Assets/Image/png/Vector.png";
import smarthub from "../../../Assets/Image/png/smart-hub.png";
import { BtnPrimary, BtnAlternative } from "../../share/buttons/Btn";
import { NavLink, Outlet } from "react-router-dom";
import { Modal } from "../../share/modal/Modal";
import Register from "../register/Register";
import { useAuth } from "../../../Context/AuthContext";
import { userContext } from "../../../Context/UserContext";
import Cookies from "js-cookie";
import Menu from "./Menu";
import LoginLayout from "./LoginLayout";

const Navbar = () => {
    return (
        <>
            <nav className="navbar py-1 rounded flex justify-center text-[#41284E] relative shadow-nav bg-[#FBF7FF] z-10 ">
                <div className=" flex justify-between items-center mx-auto flex-nowrap gap-10 container">
                    <NavLink to="/" className="flex items-center navbar__logo">
                        <img
                            src={smarthub}
                            className="ml-2 h-[8rem]"
                            alt="Logo"
                        />
                    </NavLink>
                    <Menu />
                    <LoginLayout />
                </div>
            </nav>
        </>
    );
};

export default Navbar;
